import getConfluencePage from './getConfluencePage';
import convertConfluenceHtml from './convertConfluenceHtml';

const getConfluencePageHtml = async (pageName) => {
  const { pageId, title, html, editLink } =
    (await getConfluencePage(pageName)) || {};

  const convertedHtml = convertConfluenceHtml(html);

  return { html: convertedHtml, title, pageId, editLink };
};

export default getConfluencePageHtml;
